// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".listBox[data-v-bfb72926] {\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n}\n.listBox .input[data-v-bfb72926] {\n  margin-right: 10px;\n}", ""]);
// Exports
module.exports = exports;
